import { useQuery } from 'react-query';
import type { Pagination } from '../../hooks/usePagination';
import { axiosInstance } from '../../libs/axiosConfig';
import { buildFilterUrl } from '../convertToUrl';
import type { FilterDto } from '../types/FilterDto';
import type { ApiResponse } from '../types/Response';

async function getWithFilterAndPages<T>(
	path: string,
	filter: FilterDto,
	pageSize: number,
	pageNumber: number,
) {
	return await axiosInstance
		.get(
			`${path}?${buildFilterUrl(filter)}&Number=${pageNumber}&Size=${pageSize}`,
		)
		.then((res) => res.data as ApiResponse<T>);
}

export const queryWithFilterAndPages = <T>(
	path: string,
	filter: FilterDto,
	pagination: Pagination,
) => {
	return useQuery({
		queryKey: [
			path,
			filter.pharmacyGroupName,
			filter.startDate,
			filter.endDate,
			pagination.pageSize,
			pagination.pageNumber,
		],
		queryFn: async () => {
			const data = await getWithFilterAndPages<T>(
				path,
				filter,
				pagination.pageSize,
				pagination.pageNumber,
			);

			return data;
		},
	});
};
